module.exports = __webpack_public_path__ + "static/media/05-img-03@3x.cc82a29c.webp";